import React, { Component } from 'react';
import { Spin, Button, message, Modal } from 'antd';
import Text from '../../basicElement/Text';
import LimitLength from '../../basicElement/LimitLength';
import EditableCell from '../../basicElement/EditableCell';
import API_URL from '../../../common/url';
import Fetch from '../../../common/Fetch';
import ProjectTable from './ProjectTable';
import PeriodTable from './PeriodTable';
import Sheet from './Sheet';
import format from '../../shared/format';

const CONFIG = {
    type: [
        'FIRST_EVALUATE',
        'SECOND_EVALUATE',
        'NEW_INDEPENDENT_EVALUATE'
    ],
    limitLength: 255,
    title: [
        '带教质量评估表-1',
        '带教质量评估表-2',
        '带教质量评估表-3',
    ],
    scoreDesc: [
        '第一阶段评估得分',
        '第二阶段评估得分',
        '新人独立承接项目评估得分'
    ],
    totalScoreDesc: '总得分（第一阶段评估得分+第二阶段评估得分+新人独立承接项目评估得分）',
    nextHope: [
        '下一阶段希望带教老师怎么做',
        '下一阶段希望带教老师怎么做',
        '您对带教老师及公司带教工作的建议/意见'
    ],
    nextPlan: '下一阶段你的学习计划',
    desc: [
        [
            '此评价表仅试用所有带教老师',
            '被带教员工需在第1个月后完成此带教质量评估，并制定下一步学习计划'
        ], [
            '此评价表仅试用所有带教老师',
            '被带教员工需在第2个月后完成此带教质量评估，并制定下一步学习计划'
        ],  [
            '此评价表仅试用所有带教老师',
            '被带教员工需在CTMS中产生项目工时的2个月后完成此带教质量评估'
        ],
    ],
};
// 编辑权限
const EDITABLE = {
    canEdit: true,
};
// 编辑带教老师
const EDITABLE_TEACHLEADER = {
    canEditTeacherLeader: true,
};

/**
 * type: 0、1、2 分别对应三个阶段
 */
class AssessmentSheet extends Component {
    state = {
        data: {},
        datas: [],
        loading: false,
        tableData: [],
        scoreList: [],
        teachLeaderOptions: [],
        editStatus: 'canNotEdit',
        editTeachLeader: false,
    }

    componentDidMount() {
        // 带教老师ID可能由父组件字典查询后才下发：为空时挂载不查询，等待 componentDidUpdate 中变化再查询，避免以空ID重复请求
        if (this.props.userTeacherId) {
            this.loadData();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.userTeacherId !== prevProps.userTeacherId || this.props.type !== prevProps.type) {
            this.loadData();
        }
    }

    queryTeachLeader = () => {
        const { data } = this.state;
        const { provinceId = '' } = data;
        Fetch.post(API_URL.teaching.queryTeachLeaderByProvince, {
            provinceId
        }).then((res) => {
            const { datas } = res;
            const { data } = this.state;
            if ((datas || []).length === 1) {
                data.teachLeaderId = datas[0].teachLeaderId;
            }
            const teachLeaderOptions = (datas || []).map(i => ({
                label: i.userName,
                value: i.teachLeaderId,
            }));
            this.setState({
                data,
                teachLeaderOptions,
            });
        }).catch(err => {
            console.error(err);
        });
    }

    loadData = () => {
        const { type, userTeacherId = '' } = this.props;
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.queryCrcEvaluateInfo, {
            userTeacherId,
            type: CONFIG.type[type]
        }).then(
            this.adapterData
        ).catch(err => {
            console.error(err);
        });
    }

    // 适配表格数据
    adapterData = (res) => {
        const { type, disabled = false } = this.props;
        const { data, datas, editStatus } = res;

        let scoreList,     // 分值列表
            tableData,     // 表格数据
            colSpan,       // 合并行
            tComments,     // 评估得分备注
            score;         // 总得分
        switch(type) {
            case '0':
            case '1': {
                tableData = (datas || []).map((i, idx) => {
                    const { detailList, ...rest } = i;
                    if (!scoreList) {
                        scoreList = detailList;
                    }
                    rest.number = idx + 1;
                    (detailList || []).forEach((detail, index) => {
                        rest[`detail_${index}`] = detail.itemScore;
                    });
                    rest.maxScore = detailList[0].itemScore;
                    rest.minScore = detailList[detailList.length - 1].itemScore;

                    return rest;
                });

                colSpan = 7;

                const { comments, firstEvaluateScore, secondEvaluateScore, newIndependentEvaluateScore } = data || {};
                tComments = comments;
                if (type == '0') {
                    score = (secondEvaluateScore || 0) * 1 + (newIndependentEvaluateScore || 0) * 1;
                } else {
                    score = (firstEvaluateScore || 0) * 1 + (newIndependentEvaluateScore || 0) * 1;
                }
                break;
            }
            case '2': {
                tableData = (datas || []);
                tableData.forEach((item, index) => {
                    item.number = index + 1;
                });

                colSpan = 3;

                const { firstEvaluateScore, secondEvaluateScore } = data || {};
                score = (firstEvaluateScore || 0) * 1 + (secondEvaluateScore || 0) * 1;
                break;
            }
        }
        tableData.push({
            number: <strong>{CONFIG.scoreDesc[type]}</strong>,
            comments: tComments,
            colSpan,
        }, {
            number: <strong>{CONFIG.totalScoreDesc}</strong>,
            colSpan,
            score,
        });

        this.setState({
            scoreList,
            tableData,
            loading: false,
            data: data || {},
            editTeachLeader: false,
            editStatus: disabled || editStatus,
        }, () => {
            this.queryTeachLeader();
        });
    }

    confirm = () => {
        Modal.confirm({
            title: '确定保存此次填写的带教质量评估表？',
            content: '一旦保存，评估表内容将不可再更改',
            onOk: this.save,
        });
    }

    save = () => {
        const { type, userTeacherId } = this.props;
        const { data, tableData } = this.state;
        const { teachLeaderId, nextStageHope, nextStagePlan } = data;
        if (!teachLeaderId) {
            message.warning('请选择带教组长姓名！');
            return;
        }

        const params = {};
        switch(type) {
            case '0':
            case '1': {
                for (let i = 0, len = tableData.length - 1; i < len; i++) {
                    const { score, comments, crcTeacherEvaluateId } = tableData[i];
                    if (i < len - 1) {
                        if (!score && score !== 0) {
                            message.warning('请输入得分！');
                        }
                        params[`scoreList[${i}].score`] = score;
                        params[`scoreList[${i}].comments`] = comments;
                        params[`scoreList[${i}].crcTeacherEvaluateId`] = crcTeacherEvaluateId;
                    } else {
                        params[`comments`] = comments;
                    }
                }
                if (!nextStageHope) {
                    message.warning(`请填写${CONFIG.nextHope[type]}！`);
                    return;
                } else if (!nextStagePlan) {
                    message.warning(`请填写${CONFIG.nextPlan}！`);
                    return;
                }
                break;
            }
            case '2': {
                for (let i = 0; i < tableData.length - 2; i++) {
                    const { chooseId, score, crcTeacherEvaluateId } = tableData[i];
                    if (!score && score !== 0) {
                        message.warning('请选择考核结果！');
                        return;
                    }
                    params[`scoreList[${i}].score`] = score;
                    params[`scoreList[${i}].crcTeacherEvaluateDetailId`] = chooseId;
                    params[`scoreList[${i}].crcTeacherEvaluateId`] = crcTeacherEvaluateId;
                }
                if (!nextStageHope) {
                    message.warning(`请填写${CONFIG.nextHope[type]}！`);
                    return;
                }
            }
        }
        
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.saveCrcTeacherEvaluateInfo, {
            userTeacherId,
            type: CONFIG.type[type],
            teachLeaderId,
            nextStageHope,
            nextStagePlan,
            ...params,
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({
                loading: false,
            }, () => {
                this.loadData();
            });
        }).catch(err => {
            console.error(err);
        });
    }

    handleChange = (value, key, storeObj) => {
        this.setState(prevState => ({
            [storeObj]: {
                ...prevState[storeObj],
                [key]: value,
            }
        }));
    }

    handleTableChange = (data) => {
        this.setState({ tableData: data });
    }

    handlePlanChange = (value, key) => {
        if ((value || '').length > CONFIG.limitLength) {
            message.warning(`最大可输入${CONFIG.limitLength}!`);
            return;
        }
        this.handleChange(value, key, 'data');
    }

    editTeachLeader = (editTeachLeader) => {
        this.setState({ editTeachLeader }, () => {
            !editTeachLeader && this.loadData();
        });
    }

    // 人员信息
    getInfoList = () => {
        const { editStatus, data, teachLeaderOptions, editTeachLeader } = this.state;
        const { teachLeaderId, userCompellation, employeeCode, joinTime, teacherName, leaderName } = data || {};
        const editable = EDITABLE[editStatus] || editTeachLeader;
        const result = [{
            label: '被带教员工姓名',
            value: userCompellation,
        }, {
            label: '工号',
            value: employeeCode,
        }, {
            label: '入职时间',
            value: format('date', joinTime),
        }, {
            label: '带教老师姓名',
            value: teacherName
        }, {
            label: '主管领导姓名',
            value: leaderName
        }, {
            label: <Text asterisk={editable}>带教组长姓名</Text>,
            value: (
                <div>
                    <EditableCell
                        type="Select"
                        editable={editable}
                        style={{marginRight: 10, width: 120}}
                        value={teachLeaderId}
                        config={{options: teachLeaderOptions}}
                        onChange={value => this.handleChange(value, 'teachLeaderId', 'data')}
                    />
                    {
                        EDITABLE_TEACHLEADER[editStatus] && (
                            editTeachLeader ?
                                <span>
                                    <a onClick={this.save}>保存</a>
                                    <span className="ant-divider" />
                                    <a onClick={() => this.editTeachLeader(false)}>取消</a>
                                </span>
                            :
                                <a onClick={() => this.editTeachLeader(true)}>编辑</a>
                        )
                    }
                </div>
            ),
        }];

        return result;
    }

    // 评分表
    getTable = () => {
        const { type } = this.props;
        const { tableData, scoreList, editStatus } = this.state;
        const editable = EDITABLE[editStatus];

        switch(type) {
            case '0':
            case '1':
                return <PeriodTable onChange={this.handleTableChange} data={tableData} scoreList={scoreList} editable={editable} />;
            case '2':
                return <ProjectTable onChange={this.handleTableChange} data={tableData} editable={editable} />;
        }
    }

    // 计划
    getPlanList = () => {
        const { type } = this.props;
        const { editStatus, data } = this.state;
        const editable = EDITABLE[editStatus];
        const { nextStageHope, nextStagePlan } = data || {};

        const planList = [{
        label: <Text asterisk={editable}>{CONFIG.nextHope[type]}</Text>,
            value: (
                <div>
                    <EditableCell type="TextArea" editable={editable} value={nextStageHope} onChange={value => this.handlePlanChange(value, 'nextStageHope')} />
                    <LimitLength display={editable} value={nextStageHope} />
                </div>
            )
        }];
        if (type != 2) {
            planList.push({
                label: <Text asterisk={editable}>{CONFIG.nextPlan}</Text>,
                value: (
                    <div>
                        <EditableCell type="TextArea" editable={editable} value={nextStagePlan} onChange={value => this.handlePlanChange(value, 'nextStagePlan')} />
                        <LimitLength display={editable} value={nextStagePlan} />
                    </div>
                )
            });
        }
        return planList;
    }

    render() {
        const { type, disabled } = this.props;
        const { editStatus, loading } = this.state;
        const editable = EDITABLE[editStatus];
        return (
            <Spin spinning={loading}>
                <Sheet
                    className={disabled ? '' : 'border'}
                    title={CONFIG.title[type]}
                    infoList={this.getInfoList()}
                    table={this.getTable()}
                    planList={this.getPlanList()}
                    descList={CONFIG.desc[type]}
                />
                {
                    editable &&
                    <div style={{ height: 48, lineHeight: '48px', textAlign: 'center' }}>
                        <Button type="primary" onClick={this.confirm}>保存</Button>
                    </div>
                }
            </Spin>
        );
    }
}

export default AssessmentSheet;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/Component/AssessmentSheet.js